
import React from 'react';
import { IIconBasicProps } from '../IIconBasicProps';

const RightArrowIcon: React.FC<IIconBasicProps> = ({
    width = 25,
    height = 25,
    className
}) => {
    return<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}>
<path d="M12.9463 12.6668L8.87301 8.59376C8.73468 8.45526 8.66385 8.28118 8.66051 8.07151C8.65735 7.86201 8.72818 7.68476 8.87301 7.53976C9.01801 7.39493 9.19368 7.32251 9.40001 7.32251C9.60634 7.32251 9.78201 7.39493 9.92701 7.53976L14.4213 12.034C14.5148 12.1277 14.5808 12.2264 14.6193 12.3303C14.6578 12.4341 14.677 12.5463 14.677 12.6668C14.677 12.7873 14.6578 12.8994 14.6193 13.0033C14.5808 13.1071 14.5148 13.2058 14.4213 13.2995L9.92701 17.7938C9.78851 17.9321 9.61443 18.0029 9.40476 18.0063C9.19526 18.0094 9.01801 17.9386 8.87301 17.7938C8.72818 17.6488 8.65576 17.4731 8.65576 17.2668C8.65576 17.0604 8.72818 16.8848 8.87301 16.7398L12.9463 12.6668Z" fill="#BCBEC4"/>
</svg>
}

export default  RightArrowIcon;